import { useState } from 'react';

import { SNACKBAR_AUTOHIDE_DURATION } from '@mopla/constants';

interface UseMplSnackbarOptions {
	autoHideDuration?: number;
}

interface SnackbarState {
	open: boolean;
	message: string;
}

export const useMplSnackbar = ({
	autoHideDuration = SNACKBAR_AUTOHIDE_DURATION,
}: UseMplSnackbarOptions = {}) => {
	const [snackbar, setSnackbar] = useState<SnackbarState>({
		open: false,
		message: '',
	});

	const showSnackbar = (message: string) => {
		setSnackbar({ open: true, message });
	};

	const hideSnackbar = () => {
		setSnackbar((prev) => ({ ...prev, open: false }));
	};

	return {
		snackbar,
		showSnackbar,
		hideSnackbar,
		autoHideDuration,
	};
};
